<template>
  <div>
    <p class="title"><span>{{ $t('affiliate') }}</span> > <span>{{ $t('withdrawDetails') }}</span></p>
    <div class="no-record" v-if="records.length === 0 && !loading">{{ $t('noRecords') }}</div>

    <div id="pc-records" v-if="records.length > 0">
      <div class="little-title">
        <p class="date">{{ $t('time') }}</p>
        <p class="amount">{{ $t('amount') }}</span>
        <p class="account">{{ $t('account') }}</p>
        <p class="status">{{ $t('status') }}</p>
      </div>
      <div class="records" v-for="item in records">
        <p class="date">{{ item.created_at | createFormatTime(item.created_at) }}</p>
        <p class="amount">{{ $t(item.currency_code) }} {{ item[item.currency_code] }}</p>
        <p class="account">{{ item.payment_id }}</p>
        <p class="status"><span>{{ $t(item.status) }}</span></p>
      </div>
    </div>

    <div id="pager-bar">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager :total-page="totalPage" :init-page="currentPage" @go-page="queryRecords"></pager>
    </div>

  </div>
</template>
<script>
  import {createFormatTime} from 'src/lib/filters'
  import pager from '../pager/Index.vue'
  import Spinner from '../Spinner.vue'
  import locales from './lang'

  export default {
    name: 'withdraw-detail-pc',
    components: {pager, Spinner},
    data: function () {
      return {
        records: [],
        totalPage: 0,
        currentPage: 1,
        loading: false
      }
    },
    locales,
    created() {
      this.queryRecords(this.currentPage)
    },
    methods: {
      queryRecords(data) {
        this.loading = true
        this.$http.get('api/commission-records?type=withdraw', {params: {'page': data.page}}).then((response) => {
          if (response.data.code === 0) {
            this.records = response.data.data
            this.currentPage = response.data.meta.current_page
            this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
            this.loading = false
          }
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
    letter-spacing: 0;
    border-radius: 0;
  }

  #pc-records {
    min-height: 4.5rem;
    text-align: center;
  }

  .no-record {
    text-align: center;
    font-size: .14rem;
    line-height: .16rem;
    padding: .8rem 0 .4rem;
    color: #666;
  }

  .title {
    height: .48rem;
    line-height: .48rem;
    padding: 0 .16rem;
    font-size: .16rem;
    color: #111;
    border-bottom: 1px solid #E0D7E3;
  }

  .little-title {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #333333;
    font-weight: 600;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    display: flex;
  }

  .records {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #666;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    display: flex;
  }

  #pc-records p {
    font-size: .14rem;
    display: inline-block;
    flex-basis: 25%;
  }

  #pager-bar {
    padding-bottom: .4rem;
    text-align: center;
    .spinner-component-box {
      min-height: .6rem;
      margin: .1rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// withdrawDetailsPc.vue?11a781a4